import React, { Component } from 'react'
import { getUser } from '../../../../actions/session'
import Switch from "react-switch";
import Axios from 'axios';
import { Notifications } from '../../../common/notification';
import { UPDATE_SERVER_URL } from '../../../../config/rest_endpoints';

class EditServerConfig extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            ip: '',
            port: '',
            mask: '',
            techPrefix:'',
            enforceOverRide:false,
            serverId: '',
            switched: true,
            mainid: null,
            msg:'',
            isLoad:false
        }
        this.toggleSwitch = this.toggleSwitch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onUpdateForm = this.onUpdateForm.bind(this)
        this.toggleSwitchEnforce = this.toggleSwitchEnforce.bind(this)

    }

    componentWillReceiveProps(newProps) {
        this.setState({
            ip: newProps.previousDetails.ip,
            port: newProps.previousDetails.port,
            mask: newProps.previousDetails.mask,
            techPrefix: newProps.previousDetails.techPrefix,
            serverId: newProps.previousDetails.id,
            switched: newProps.previousDetails.enabled,
            mainid: newProps.mainID
        })
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    toggleSwitch() {
        this.setState({ switched: !this.state.switched })
    }

    clearForm() {
        this.setState({
            title: '',
            ip: '',
            port: '',
            mask: '',
            switched: true
        })
    }

    onUpdateForm() {
        const { ip, port, mask,techPrefix,enforceOverRide, switched, User, serverId,mainid } = this.state
        var payLoad = {
            "ip": ip,
            "port": parseInt(port),
            "mask": parseInt(mask),
            'techPrefix':techPrefix,
            'enforceOverRide':enforceOverRide,
            "enabled": switched
        }
        this.setState({isLoad:true})
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.put(`${UPDATE_SERVER_URL}/${mainid}/server/${serverId}/update`, payLoad, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                this.setState({
                    msg: res.data.message,
                    isLoad:false
                })
                Notifications.notify(this.state.msg, "Updated", "success")
                this.props.close()
                this.props.serverListing()

            }
        }).catch(err => {
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            Notifications.notify(msessage, "Failed", "error")
            this.setState({isLoad:false})
        })
    }

    toggleSwitchEnforce() {
        this.setState({ enforceOverRide: !this.state.enforceOverRide })
    }

    render() {
        const { ip, port, mask,techPrefix,enforceOverRide,  switched, isLoad } = this.state

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        const switchRowStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 14px',
            background: '#F8FAFC',
            borderRadius: '10px',
            border: '1px solid #E2E8F0',
            marginBottom: '12px'
        };

        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Source IP</label>
                            <input type="text" className="form-control" name="ip" value={ip} onChange={this.handleChange} placeholder="Enter source IP" required />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Tech Prefix</label>
                            <input type="text" className="form-control" name="techPrefix" value={techPrefix} onChange={this.handleChange} placeholder="Enter tech prefix" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Port</label>
                            <input type="number" className="form-control" name="port" value={port} onChange={this.handleChange} placeholder="Enter port" required />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Mask</label>
                            <input type="number" className="form-control" name="mask" value={mask} onChange={this.handleChange} placeholder="Enter mask" required />
                        </div>
                    </div>
                </div>
                <div style={switchRowStyle}>
                    <span style={{fontSize:'13px',fontWeight:'500',color:'#475569'}}>Enabled</span>
                    <Switch onChange={this.toggleSwitch} checked={switched} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                </div>
                <div style={switchRowStyle}>
                    <span style={{fontSize:'13px',fontWeight:'500',color:'#475569'}}>Enforce Override</span>
                    <Switch onChange={this.toggleSwitchEnforce} checked={enforceOverRide} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                </div>
                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        disabled={isLoad}
                        onClick={this.onUpdateForm}
                        style={{
                            background: isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Update Server
                        <i className={isLoad ? "icon-spinner4 spinner" : "icon-file-plus"} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}
export default EditServerConfig